import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Card, Modal, Row, Col } from "react-bootstrap";
import { MdEdit } from "react-icons/md";
import { MODULES, ROLE_GROUPS } from "../../../auth/roles";

import {
  useGetMdocsStatus,
  useSendProjectToMdocs,
} from "../../../services/ProjectDetails/mdocsAPI";
import { useProjectDetailsContext } from "../../../context/ProjectDetailsContext";
import RoleGuard from "../../../auth/RoleGuard";

const MdocsPanel = () => {
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const { project, isLoading } = useProjectDetailsContext();

  const existsInMDocs = project?.mDocs === true;

  const { mutate: sendToMdocs, isError } = useSendProjectToMdocs(id);

  const handleConfirm = () => {
    sendToMdocs(undefined, {
      onSuccess: () => {
        setShowModal(false);
      },
    });
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Modal.Body>
          <Row>
            <Col>Želite vnesti obstoječ projekt v MDocs?</Col>
          </Row>
          {isError && (
            <Row>
              <Col>
                <span className="text-danger mt-2 d-block">
                  Prišlo je do napake pri kreiranju projekta v MDocs!
                </span>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConfirm}>
            Potrdi vnos v MDocs
          </Button>
          <Button variant="outline-primary" onClick={() => setShowModal(false)}>
            Prekliči
          </Button>
        </Modal.Footer>
      </Modal>

      <Card className="mdocs-panel">
        <div className="d-flex align-items-center justify-content-between">
          <span>
            {existsInMDocs ? "Projekt je vnešen v MDocs." : "Ustvari v MDocs"}
          </span>
          {!existsInMDocs && (
            <RoleGuard
              moduleKey={MODULES.PROJEKTI}
              roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
              vodilnaClanicaProjektaID={project?.clanicaID}
            >
              <button
                onClick={() => setShowModal(true)}
                className="btn btn-sm btn-outline-primary border-0"
              >
                <span className="d-flex align-items-center gap-1">
                  Kreiraj <MdEdit />
                </span>
              </button>
            </RoleGuard>
          )}
        </div>
      </Card>
    </>
  );
};

export default MdocsPanel;
